import { render, staticRenderFns } from "./returnProfit.vue?vue&type=template&id=a44e1616&"
import script from "./returnProfit.vue?vue&type=script&lang=js&"
export * from "./returnProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports